import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { BCPCloudUpload } from "../icons/bcp/BCPIcons";
import { postData } from "./UtilityFunctions";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

export async function uploadFileToS3(file, options) {
  try {
    if (!file?.type) {
      throw new Error("Missing file type");
    }
    const additionalBody = {};
    if (options?.path) {
      additionalBody.path = options.path;
    }
    if (options?.public) {
      additionalBody.public = options.public;
    }

    const apiFile = await postData("/files", {
      body: {
        mimetype: file.type,
        ...additionalBody
      }
    });

    if (apiFile?.url) {
      const uploadResult = await fetch(apiFile?.url, {
        method: "PUT",
        headers: {
          "Content-Type": file.type
        },
        body: file
      });
      if (!uploadResult?.ok) {
        const errorData = await uploadResult.json().catch(() => null);
        throw new Error(
          `S3 upload failed: ${uploadResult.status} - ${errorData?.error || "Unknown error"}`
        );
      }

      return apiFile;
    }
    throw new Error("Error getting upload info");
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export default function FileUploader({
  name,
  multiple,
  accept,
  label,
  setFieldValue
}) {
  const _label = label || (multiple ? "Upload files" : "Upload File");
  const onChange = (e) => {
    if (setFieldValue) {
      setFieldValue(name, multiple ? e.target?.files : e.target?.files?.[0]);
    }
  };
  return (
    <Button
      component="label"
      variant="contained"
      tabIndex={-1}
      startIcon={<BCPCloudUpload />}
    >
      {_label}
      <VisuallyHiddenInput
        type="file"
        onChange={onChange}
        multiple={multiple}
        accept={accept}
      />
    </Button>
  );
}
